import React from 'react'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { payPlanMobx, memberMobx, thirdPartyMobx, payChannelMobx } from '@mobxStore'
import { observer } from 'mobx-react'
import { modalLayer, confirmLayer, getPlatform } from '@utils'
import { format } from '@dt/fe-utils'
import { Pay, PayButton } from '@pages/checkout/component'
import AddGift from '@pages/checkout/component/Pay/AddGift'
import '../Pay/index.scss'
import './index.scss'

interface IProps {
  reject?: () => void;
  saveError?: () => void;
}

const SettlementCard: React.FC<IProps> = ({ reject, saveError }) => {
  const { isAliPayMiniProgram } = getPlatform()

  const handleClick = () => {
    confirmLayer({
      title: '',
      children: <p>{i18n.t('pay.closePayModalTip')}</p>,
      confirmText: i18n.t('pay.leavePay'),
      cancelText: i18n.t('pay.continuePay'),
      className: 'pay-confirm-modal',
    }).then(() => {
      modalLayer.closeAll()
    }).catch(() => {})
  }

  return (
    <IonModal
      isOpen
      cssClass='settlement-card height620-modal'
      onDidDismiss={() => {
        payPlanMobx.setUserChangedPlan(false)
        reject && reject()
      }}
    >
      <IonHeader>
        <div className='settlement-card-header'>
          <span>{i18n.t('pay.pay')}</span>
          <i className='iconfont icon-close' data-cypid='settlementCardClose' onClick={handleClick} />
        </div>
      </IonHeader>
      <IonContent class='settlement-card-content'>
        <div className='pay-amount' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency((payPlanMobx.totalAmount || 0) - thirdPartyMobx.couponResult.offPrice) }}></div>
        <div className='settlement-card-pay'>
          <Pay />
          {!isAliPayMiniProgram && !memberMobx.brandConfig.mobileGiftcardPayMustBind && payChannelMobx.availableGiftCardMethod ? <AddGift /> : ''}
        </div>
      </IonContent>
      <IonFooter className='settlement-card-footer'>
        <PayButton saveError={saveError} />
      </IonFooter>
    </IonModal>
  )
}

export default observer(SettlementCard)
